export const REVIEW_DISABLED = 'disabled';
// export const REVIEW_NEEDS_LOGIN = 'login';
// export const REVIEW_UNAVAILABLE = 'unavailable';
export const REVIEW_AVAILABLE = 'available';
export const REVIEW_ALREADY_REVIEWED = 'reviewed';
